import { useState } from 'react'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import reactLogo from './assets/react.svg'
import { Toaster } from "@/components/ui/sonner"
import './App.css'
import Main from './components/Main'
import Checkout from "./components/Checkout";
import Success from "./components/Success";
import Cancel from "./components/Cancel";
import { inject } from '@vercel/analytics';
import Landing from "./components/Landing";
import Contact from "./components/Contact";
import About from './components/About'
import SignIn from './components/SignInPage'
import PricingPage from './components/PricingPage'
import ForgotPasswordPage from './components/ForgotPasswordPage'
import SignUp from './components/SignUpPage'
import Example from './components/Example'
import HomepageRedesign from './components/HomepageRedesign'
import { SidebarProvider } from './contexts/SidebarContext';



// import posthog from 'posthog-js'


// // posthog.init('phc_BRIbzr6ppAAOxMXFMnLyu4RSDxNIZgg6paOA9xG9bEP', { api_host: 'https://us.i.posthog.com' })
// import { PostHogProvider } from 'posthog-js/react'

// posthog.init('phc_BRIbzr6ppAAOxMXFMnLyu4RSDxNIZgg6paOA9xG9bEP', {
//   api_host: "https://us.i.posthog.com",
// })
inject();

function App() {
  const [count, setCount] = useState(0)

  return (
    <SidebarProvider>

      <Router basename={process.env.PUBLIC_URL}>
        <Example />
        <Toaster position="top-center" richColors />

            <Routes>
              <Route index element={<HomepageRedesign />} />
              <Route path="legacy" element={<Main />} />
              <Route path="success" element={<Success />} />
              <Route path="cancel" element={<Cancel />} />
              <Route path="contact" element={<Contact />} />
              <Route path="about" element={<About />} />
              <Route path="signin" element={<SignIn />} />
              <Route path="forgotpassword" element={<ForgotPasswordPage />} />
              <Route path="signup" element={<SignUp />} />
            </Routes>
      </Router>
      </SidebarProvider>

  );
}

export default App
